import { render, staticRenderFns } from "./PaymentInfo.vue?vue&type=template&id=7bf71856&scoped=true&"
import script from "./PaymentInfo.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PaymentInfo.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PaymentInfo.vue?vue&type=style&index=0&id=7bf71856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf71856",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf71856')) {
      api.createRecord('7bf71856', component.options)
    } else {
      api.reload('7bf71856', component.options)
    }
    module.hot.accept("./PaymentInfo.vue?vue&type=template&id=7bf71856&scoped=true&", function () {
      api.rerender('7bf71856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/PaymentInfo.vue"
export default component.exports